/**
 * 文件上传相关常量
 * 
 * 与后端Transloadit模板保持一致的文件类型和大小限制：
 * 1. 图片文件 (JPEG, PNG, GIF, WebP) - 最大5MB
 * 2. PDF文件 - 最大36MB
 * 3. 文本文件 (包括各种代码文件、SVG等) - 最大1MB
 * 4. 可转换文档 (Office文档等) - 最大36MB
 */

// 图片类型 - 对应 filtered-images
export const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const MAX_SIZE_IMAGE = 5 * 1024 * 1024; // 5MB

// PDF类型 - 对应 filtered-pdfs
export const SUPPORTED_PDF_FORMATS = ['application/pdf'];
export const MAX_SIZE_PDF = 36 * 1024 * 1024; // 36MB (37748736 bytes)

// 文本文件类型 - 对应 filtered-textfiles
export const SUPPORTED_TEXT_FORMATS = [
  'text/*',
  'application/json',
  'application/javascript',
  'application/typescript',
  'application/xml',
  'application/xhtml+xml',
  'application/x-httpd-php',
  'application/x-sh',
  'application/x-perl',
  'application/x-python',
  'application/x-ruby',
  'application/x-javascript',
  'application/x-php',
  'application/x-typescript',
  'application/x-yaml',
  'application/x-toml',
  'application/x-tex',
  'application/x-java',
  'application/x-c',
  'application/x-c++',
  'application/x-csharp',
  'application/x-swift',
  'application/x-kotlin',
  'application/x-go',
  'application/x-rust',
  'application/x-scala',
  'application/x-groovy',
  'application/x-dart',
  'application/x-sql',
  'application/x-lua',
  'application/x-haskell',
  'application/x-lisp',
  'application/x-r',
  'application/x-matlab',
  'application/xml-dtd',
  'application/x-csv',
  'application/x-markdown',
  'application/x-msdos-batch',
  'application/x-powershell',
  'application/x-cmake',
  'application/graphql',
  'application/x-latex',
  'application/x-tex',
  'application/x-texinfo',
  'application/x-troff',
  'application/x-ini',
  'application/x-config',
  'application/x-log',
  'application/x-properties',
  'application/x-env',
  'image/svg+xml'
];
export const MAX_SIZE_TEXT = 1 * 1024 * 1024; // 1MB (1048576 bytes)

// 可转换文档类型 - 对应 filtered-convertibles
export const SUPPORTED_CONVERTIBLE_FORMATS = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.ms-excel',
  'application/vnd.ms-word',
  'application/vnd.oasis.opendocument.*',
  'application/postscript',
  'application/rtf',
  'application/x-rtf'
];
export const MAX_SIZE_CONVERTIBLE = 36 * 1024 * 1024; // 36MB (37748736 bytes)

// 特殊文件大小限制
export const MAX_SIZE_OCTET_STREAM = 50 * 1024; // 50KB
export const MAX_SIZE_X_APPLICATION = 100 * 1024; // 100KB

export const ALL_ALLOWED_MIME_TYPES = [
  ...SUPPORTED_IMAGE_FORMATS,
  ...SUPPORTED_PDF_FORMATS,
  ...SUPPORTED_TEXT_FORMATS,
  ...SUPPORTED_CONVERTIBLE_FORMATS
];


export const MAX_NUMBER_OF_FILES = 10
